import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=7ade7535&"
import script from "./PageHeader.vue?vue&type=script&lang=js&"
export * from "./PageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/tonyj/Documents/Proyectos/lastedchange/transit-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbsItem } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
installComponents(component, {VBreadcrumbsItem,VContainer})
